import { signal } from '@angular/core';
import { Upload } from '@app/shared/services/upload.service';
import { PortalError } from '@app/utils/error/portal-error';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

export function componentState() {
  const busy = signal<boolean>(false);
  const busyWith = signal<number | string | null>(null);
  const error = signal<PortalError | null>(null);

  return {
    busy,
    busyWith,
    error,
    handle,
  };

  function handle<T>(observable$: Observable<T>, id?: number | string): Observable<T> {
    return new Observable((subscriber) => {
      busy.set(true);
      busyWith.set(id);

      observable$
        .pipe(
          finalize(() => {
            busy.set(false);
            busyWith.set(null);

            subscriber.complete();
          })
        )
        .subscribe({
          error: (err) => {
            error.set(err);
          },
          next: (value) => {
            subscriber.next(value);
          },
        });
    });
  }
}

export function uploadComponentState() {
  const state = componentState();
  const progress = signal<number | null>(null);

  return {
    ...state,
    handle,
    progress,
  };

  function handle<T extends Upload<U>, U>(observable$: Observable<T>, id?: number | string): Observable<T> {
    return state.handle(observable$.pipe(setProgress()), id);
  }

  function setProgress<T extends Upload<any>>(): MonoTypeOperatorFunction<T> {
    return tap<T>({
      error: () => progress.set(null),
      next: (upload: T) => progress.set(upload.progress),
    });
  }
}
